import CustomTooltip from "../tooltip";
import ImageWrapper from "../image-wrapper";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useState } from "react";

const CopyToClipboard = (props) => {
    const {
        text = "",
        className = "",
        tooltipContent = "",
        id = "",
        onClick = () => {},
        testId = "",
        img:defaultImg = "common/copy",
        width = 17,
        height = null
    } = props;

    const [src, setSrc] = useState(defaultImg);
    /**
     * Copy To ClipBoard
     * @param textField
     */
    const copyToClipBoard = async (textField) => {
        await navigator.clipboard.writeText(textField);
        setSrc("common/success");
        setTimeout(() => {
            setSrc(defaultImg);
        }, 1000);
    };
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
        copyToClipBoard(text);
    };
    return (
        <>
            <ImageWrapper src={`${src}.svg`}
                className={classnames("copy-icon cursor-pointer", { [className]: className })}
                onClick={handleClick}
                width={width}
                height={height}
                
                testId={`copy-${testId}`}
                id={id}/>
            {Boolean(tooltipContent) && (
                <CustomTooltip content={tooltipContent} target={id} />
            )}
        </>
    );
};

export default CopyToClipboard;

CopyToClipboard.propTypes = {
    text          : PropTypes.string,
    className     : PropTypes.string,
    tooltipContent: PropTypes.string,
    id            : PropTypes.string,
    children      : PropTypes.node,
    onClick       : PropTypes.func,
    width         : PropTypes.number,
    testId        : PropTypes.string
};

